import { types } from '../actions/SessionActions';
import { types as fedopsTypes } from '@wix/restaurants-redux/dist/actions/FedopsActions';
import _ from 'lodash';

const STEPS = {
    START: 0,
    FORM: 1,
    SUCCESS: 2,
    SMS_VALIDATION: 3,
    ERROR: 4,
    NOT_ENABLED: 5
};

let INITIAL_STATE = {
    step: STEPS.START,
    preview: false,
    isEnabled: false,
    loaded: {
        date: false,
        time: false,
        party: false
    },
    reserveResponse: null,
    showPolicy:false,
    showTerms:false,
    errorResponse: null,
    stepOptions: STEPS,
    interactions: {},
    isSendingReservation: false
};

const HANDLERS = {
    [types.SET_STEPS]: (payload, state) => {
        const { step, stepOptions } = payload;
        let newState = _.cloneDeep(state);
        return {...newState, step, stepOptions};
    },

    [types.SET_ACTIVATION_STATUS]: (payload, state) => {
        const { isEnabled } = payload;
        let newState = _.cloneDeep(state);

        if (state.isEnabled !== isEnabled) {
            newState = {...state, isEnabled};

            if (isEnabled) {
                newState.preview = false;
            }
        }

        return newState;
    },

    [types.SHOW_DETAILS_FORM]: (payload = {}, state) => {
        let newState = _.cloneDeep(state);
        return {...newState, step: STEPS.FORM, preview: !!payload.preview};
    },

    [types.SHOW_POLICY]: (payload = {}, state) => {
        let newState = _.cloneDeep(state);
        return {...newState, showPolicy:true};
    },

    [types.HIDE_POLICY]: (payload = {}, state) => {
        let newState = _.cloneDeep(state);
        return {...newState, showPolicy:false};
    },
    [types.SHOW_TERMS]: (payload = {}, state) => {
        let newState = _.cloneDeep(state);
        return {...newState, showTerms:true};
    },

    [types.HIDE_TERMS]: (payload = {}, state) => {
        let newState = _.cloneDeep(state);
        return {...newState, showTerms:false};
    },

    [types.FORM_END]: (payload, state) => {
        let newState = _.cloneDeep(state);

        switch (state.step) {
            case STEPS.SUCCESS:
            case STEPS.PREVIEW_SUCCESS:
                newState = _.cloneDeep(INITIAL_STATE);
                newState.isEnabled = state.isEnabled;
                newState.preview = state.preview;
                newState.loaded = _.clone(state.loaded);
                break;
            default:
                newState.step = STEPS.START;
        }

        return newState;
    },

    [types.RESERVATION_SUCCESS]: (payload = {}, state) => {
        let newState = _.cloneDeep(INITIAL_STATE);
        return {...newState, isEnabled: state.isEnabled, step: STEPS.SUCCESS, preview: !!payload.preview, loaded: _.clone(state.loaded)};
    },

    [types.RESERVATION_ERROR]: (payload, state) => {
        let newState = _.cloneDeep(state);
        return {...newState, step: STEPS.ERROR};
    },

    [types.SHOW_SMS_VALIDATION]: (payload, state) => {
        let newState = _.cloneDeep(state);
        return {...newState, step: STEPS.SMS_VALIDATION};
    },

    [types.SHOW_NOT_ENABLED]: (payload = {}, state) => {
        let newState = _.cloneDeep(state);
        return {...newState, step: STEPS.NOT_ENABLED, preview: !!payload.preview};
    },

    [types.GOTO_START]: (payload, state) => {
        let newState = _.cloneDeep(state);
        return {...newState, step: STEPS.START, isSendingReservation: false};
    },

    [types.RESERVATION_RESPONSE]: (payload, state) => {
        const { reserveResponse, errorResponse } = payload;
        let newState = {..._.cloneDeep(state)};

        if (reserveResponse) {
            newState.reserveResponse = reserveResponse;
        }
        if (errorResponse) {
            newState.errorResponse = errorResponse;
        }

        return newState;
    },

    [types.DROPDOWN_READY]: (payload, state) => {
        const { type } = payload;
        let newState = _.cloneDeep(state);

        newState.loaded[type] = true;

        return newState;
    },

    [types.SET_INTERACTIONS]: (payload, state) => {
        const { interactions } = payload;
        let newState = _.cloneDeep(state);

        newState.interactions = interactions || {};

        return newState;
    },

    [fedopsTypes.INTERACTION_START]: (payload, state) => {
        const { name } = payload;
        const newState = _.cloneDeep(state);

        if (state.interactions[name]) {
            console.warn(`[Session Store - INTERACTION_START]: interaction ${name} has been triggered twice without ending!`);
        }

        if (!newState.interactions[name]) {
            newState.interactions[name] = 0;
        }

        newState.interactions[name] += 1;

        return newState;
    },

    [fedopsTypes.INTERACTION_END]: (payload, state) => {
        const { name } = payload;
        const newState = _.cloneDeep(state);

        if (!state.interactions[name]) {
            console.warn(`[Session Store - INTERACTION_END]: interaction ${name} hasn't been triggered!`);
        }

        newState.interactions[name] -= 1;

        return newState;
    },

    [types.SUBMIT_FULL_RESERVATION_FORM_START]: (payload, state) => {
        const newState = _.cloneDeep(state);
        return Object.assign({}, newState, {isSendingReservation: true});
    },

    [types.SUBMIT_FULL_RESERVATION_FORM_END]: (payload, state) => {
        const newState = _.cloneDeep(state);
        return Object.assign({}, newState, {isSendingReservation: false});
    }
};

export default function(state = INITIAL_STATE, action = {}) {
    let handler = HANDLERS[action.type] || (() => state);
    return handler(action.payload, state);
}
